import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6 mb-3" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "col-md-6 mb-3" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-md-12 mb-3" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "col-md-12 mb-3" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "col-md-12" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = {
  ref: "submitButton",
  class: "btn btn-primary me-3",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal fade", { 'show d-block': _ctx.visible }]),
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "addRapportModalLabel",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("h4", {
            class: "modal-title",
            id: "addRapportModalLabel"
          }, "Ajouter un rapport", -1)),
          _createElementVNode("button", {
            class: "btn-close py-0",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
            "aria-label": "Close"
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", null, "Ajouter un rapport pour : " + _toDisplayString(_ctx.selectedClient?.nomClient) + " " + _toDisplayString(_ctx.selectedClient?.prenomClient), 1),
          _createVNode(_component_Form, {
            ref: "passForm",
            onSubmit: _ctx.addRapport,
            "validation-schema": _ctx.passSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                      _createTextVNode(" Date de relance "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "dateRelance",
                      type: "datetime-local",
                      value: _ctx.getCurrentDateTime(),
                      readonly: "",
                      class: "form-control shadow-none fs-md-15 text-black"
                    }, null, 8, ["value"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "dateRelance",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                      _createTextVNode(" Échéance "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "echeanceId",
                      as: "select",
                      class: "form-control shadow-none fs-md-15 text-black"
                    }, {
                      default: _withCtx(() => [
                        _cache[4] || (_cache[4] = _createElementVNode("option", { value: "" }, "Sélectionner une échéance", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.echeancesOptions, (echeance) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: echeance.id,
                            value: echeance.id
                          }, _toDisplayString(_ctx.formatEcheanceLabel(echeance)), 9, _hoisted_10))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "echeanceId",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                      _createTextVNode(" Description "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "description",
                      as: "textarea",
                      cols: "15",
                      rows: "3",
                      placeholder: "Entrer la description",
                      class: "form-control shadow-none rounded-0 text-black"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "description",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                      _createTextVNode(" Canal utilisé "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "canalUtilise" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          options: _ctx.canalOptions,
                          searchable: true,
                          placeholder: "Sélectionner le canal",
                          multiple: false
                        }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "canalUtilise",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", _hoisted_17, "Ajouter le rapport", 512),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                    }, "Fermer")
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ], 2))
}